import { Autocomplete, Box, TextField } from '@mui/material';
import React from 'react';
import styles from './bookingsGridAutocompleteCell.styles';

const BookingsGridAutocompleteCell = ({ params, options, onEdit }) => {
  const currentValue =
    typeof params?.value === 'object' && params?.value !== null
      ? params.value.value
      : params?.value;

  let selectedOption = options?.find(
    (item) => item?.value === currentValue || item?.id === currentValue
  );

  let fallbackOption = null;
  if (!selectedOption && currentValue && currentValue !== 'none') {
    fallbackOption = {
      value: currentValue,
      text: currentValue,
      label: currentValue,
      isInactive: true,
    };
    selectedOption = fallbackOption;
  }

  const effectiveOptions = fallbackOption
    ? [fallbackOption, ...options]
    : options;

  const handleChange = (_, newValue) => {
    const newValueStr = newValue?.value;
    if (newValueStr === currentValue) {
      return;
    }
    onEdit({
      newValue: newValueStr === 'none' || !newValueStr ? '' : newValueStr,
      field: params.field,
      id: params.row.id,
      row: params.row,
    });
  };

  return (
    <Box sx={styles.wrapper}>
      <Autocomplete
        disablePortal
        value={selectedOption}
        onChange={handleChange}
        disableClearable
        options={effectiveOptions}
        isOptionEqualToValue={(option, value) =>
          option?.value === value?.value || option?.id === value?.id
        }
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          if (typeof option === 'number') {
            return String(option);
          }
          return option?.text || option?.label || option?.name || '';
        }}
        sx={styles.autocomplete}
        renderInput={(paramsInput) => (
          <TextField {...paramsInput} variant="standard" />
        )}
      />
    </Box>
  );
};

export default BookingsGridAutocompleteCell;
